import styled, { css } from "styled-components";
import { Tooltip } from "../../components";

export const StyledContainer = styled(Tooltip)<{
  $closed?: boolean;
}>`
  --radius: 0.25rem;
  --inset: -0.125rem;
  position: relative;
  display: inline-flex;
  flex-direction: row-reverse;
  align-items: center;
  border-radius: var(--radius);
  background-color: transparent;
  transition: all 0.3s ease;
  background-color: rgb(240 240 240 / 30%);

  ${({ $closed }) =>
    $closed &&
    css`
      background-color: transparent;
    `}

  &:hover {
    background-color: rgb(240 240 240 / 60%);
  }
`;

export const StyledWrapper = styled.div<{
  $closed?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  overflow: hidden;
  transition: all 0.3s ease;
  padding: 1.5rem 1rem;

  ${({ $closed }) =>
    $closed &&
    css`
      padding: 0;
    `}
`;

export const StyledWidget = styled.div`
  max-width: 45rem;
  width: 100%;
  display: inline-flex;
  justify-content: end;
  position: relative;
`;

export const StyledChat = styled.div`
  position: relative;

  width: 100%;
  min-width: calc(100vw - 2.5rem);
  max-width: calc(100vw - 2.5rem);
  height: 90dvh;

  @media screen and (min-width: 48em) {
    height: auto;
    min-width: unset;
    max-width: none;
  }
`;

export const StyledLinksWrapper = styled.div<{
  $closed?: boolean;
}>`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  transition: all 0.3s ease;
  width: auto;
  opacity: 1;
  position: relative;

  & > [data-tooltip] {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.125rem;
    color: #000;
    text-decoration: none;

    &:hover::after {
      content: attr(data-tooltip);
      color: #000;
      font-size: 0.65rem;
      white-space: nowrap;
    }
  }

  ${({ $closed }) =>
    $closed &&
    css`
      width: 0;
      margin-right: 0;
      opacity: 0;
      padding: 0;
      height: 0;
      overflow: hidden;
    `}
`;

export const StyledIcon = styled.a`
  --size: 2rem;
  font-family: system-ui, sans-serif;
  width: var(--size);
  height: var(--size);
  font-size: var(--size);
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  transition: all 0.3s ease;

  .anticon {
    font-size: 2rem;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

export const StyledFloatButton = styled.button`
  background-color: transparent;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius);
  border: 0;
  padding: 0;
  margin: 0.5rem;
  color: var(--main-color);
  flex-shrink: 0;
  z-index: 9999;
  cursor: pointer;
  font-size: 2rem;
  transition: all 0.3s ease;
  overflow: hidden;
  transition: all 0.3s ease;

  .anticon {
    margin: 0.5rem;
  }

  &:hover {
    transform: scale(1.1);
  }

  img {
    width: 4.375rem;
    height: 4.375rem;
  }
`;

export const StyledChatButton = styled.button`
  --size: 2rem;
  width: var(--size);
  height: var(--size);
  color: var(--main-color);
  padding: 0;
  font-size: var(--size);
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: transparent;
  transition: all 0.3s ease;

  .anticon svg {
    fill: none;
  }

  img {
    width: var(--size);
    height: var(--size);
    flex-grow: 1;
  }

  &:hover {
    transform: scale(1.1);
  }
`;
